export enum SnackBarType {
	SUCCESS = 0,
	ERROR = 1
}